module.exports = __webpack_public_path__ + "img/campagna-amica-mercato.7d219a73.png";